// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".opacity-0[data-v-4c36b2cc]{opacity:0}.market-down-arrow[data-v-4c36b2cc],.market-up-arrow[data-v-4c36b2cc]{position:absolute !important;top:20% !important;left:5px !important;z-index:1 !important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
